<template>
  <div class="block latestPostBlock">
    <v-container>
      <h2 class="text-center white--text"><strong>My Latest Work</strong></h2>
      <v-row>
        <v-col v-for="item in items" :key="item.id" cols="6" md="4">
          <v-card outlined class="mx-auto">
            <a href="https://buffl.co/">
              <v-img
                class="white--text align-end"
                height="200px"
                :src="item.src"
              >
                <v-card-title>{{ item.title }}</v-card-title>
              </v-img>
            </a>
            <v-card-subtitle class="pb-0">{{ item.subtitle }}</v-card-subtitle>
            <v-card-text class="text--primary">
              <div>{{ item.description }}</div>
            </v-card-text>
            <v-card-actions>
              <v-expansion-panels>
                <v-expansion-panel v-for="(item, i) in 1" :key="i">
                  <v-expansion-panel-header>More</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    Create and share flashcards and online courses. Online Self
                    learning platform by creating flashcards, share with you
                    friends.
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- </template> -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "LatestPost",
  data: () => ({
    show: false,
    items: [
      {
        id: 1,
        title: "Buffl",
        subtitle: "Create and share flashcards and online courses.",
        description: "Technologies: ReactJs + Redux,NodeJs, Flutter for Mobile",
        src: require("../assets/images/buffl.png"),
      },
    ],
  }),
};
</script>
